import { post } from 'core_main/request';
import { KustomerErrorResponse } from 'globals/types';
import { PUBNUB_AUTH_V1_ENDPOINT, PUBNUB_AUTH_V2_ENDPOINT } from './constants';
import { PubnubAuthOptions } from './types';

export const createAuthForTrackingToken = (options: PubnubAuthOptions) => {
  if (options.version === 1) {
    return post(PUBNUB_AUTH_V1_ENDPOINT);
  }
  return post(PUBNUB_AUTH_V2_ENDPOINT, {
    body: JSON.stringify({
      authVerified: options.outboundChatEnabled,
    }),
  }).then((response) => {
    return response?.data
      ? {
          token: response.data.attributes?.sharedKeyset?.token,
          ttl: response.data.attributes?.ttl,
        }
      : undefined;
  });
};

export const backoffAuthCall = (
  options: PubnubAuthOptions,
  retryCount = 0,
  delay = 100,
) => {
  return createAuthForTrackingToken(options)
    .catch((error: KustomerErrorResponse) => {
      const isNotPubNubNetworkFailure = error?.title !== 'PubNubNetworkFailure';

      if (retryCount === 3 || isNotPubNubNetworkFailure) {
        return Promise.reject(error);
      }

      return new Promise((resolve) => {
        setTimeout(() => resolve(error), delay);
      });
    })
    .then((res) => {
      if (res instanceof Error)
        return backoffAuthCall(options, retryCount + 1, delay * 4);
      return res;
    });
};
